export function Text(props) {
  return (
    <textarea
      className="border border-gray-500 rounded-md p-2 width=200px weight=500px"
      {...props}
    />
  );
}
